/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nav_logging_out = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logging out...`)
};

const zh_hans1_nav_logging_out = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在退出…`)
};

const zh_hant1_nav_logging_out = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在登出…`)
};

const fr_nav_logging_out = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déconnexion…`)
};

const de_nav_logging_out = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abmelden…`)
};

const ja_nav_logging_out = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ログアウト中…`)
};

const ko_nav_logging_out = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로그아웃 중...`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nav_logging_out = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nav_logging_out(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("nav_logging_out", locale)
	if (locale === "en") return en_nav_logging_out(inputs)
	if (locale === "zh-Hans") return zh_hans1_nav_logging_out(inputs)
	if (locale === "zh-Hant") return zh_hant1_nav_logging_out(inputs)
	if (locale === "fr") return fr_nav_logging_out(inputs)
	if (locale === "de") return de_nav_logging_out(inputs)
	if (locale === "ja") return ja_nav_logging_out(inputs)
	return ko_nav_logging_out(inputs)
};